import React from 'react';
import { IDispositionSpecialOption } from '../../models/dispositionConfig';
import { ConfigurationService } from '../../services/ConfigurationService';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import enUS from 'date-fns/locale/en-US';
import fr from 'date-fns/locale/fr';
import frCA from 'date-fns/locale/fr-CA';
import de from 'date-fns/locale/de';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { Accordion, AccordionTitleProps, Icon, Input, InputOnChangeData, Menu } from 'semantic-ui-react';
import { ISpecialOptionsStateMap } from './DispositionPane';

// register locales for react-datepicker
registerLocale('en-US', enUS);
registerLocale('fr-FR', fr);
registerLocale('fr', fr);
registerLocale('fr-CA', frCA);
registerLocale('de-DE', de);
registerLocale('de', de);
registerLocale('es-ES', es);
registerLocale('es', es);

export const DispositionSpecialMultiSelectMenuItem = (
  index: number,
  label: string,
  specialOption: IDispositionSpecialOption,
  brandCode: string,
  selectedMultiDisposition: string[],
  setSelectedMultiDisposition: (value: string[]) => void,
  specialOptionsState: ISpecialOptionsStateMap,
  setSpecialOptionsState: (value: ISpecialOptionsStateMap) => void,
  activeIndex: number,
  setActiveIndex: (value: number) => void,
  config: ConfigurationService,
  agentLang: string
) => {
  const updateIndex = (event: React.MouseEvent, data: AccordionTitleProps): void => {
    const newIndex = activeIndex === (data.index as number) ? -1 : (data.index as number);
    setActiveIndex(newIndex);
  };

  if (specialOption.specialOptionType === 'sendEmail') {
    const onChange = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
      const email = data.value;
      setSpecialOptionsState({ ...specialOptionsState, [label]: { value: email } });
      let newDispositions = selectedMultiDisposition.filter(
        d => !d.startsWith(`sendEmail#${specialOption.specialOptionDispositionPrefix}#`)
      );
      if (email) {
        newDispositions.push(
          `sendEmail#${specialOption.specialOptionDispositionPrefix}#${email}`
        );
      }
      setSelectedMultiDisposition(newDispositions);
    };

    const content = (
      <Input
        placeholder={specialOption.specialOptionLabel}
        style={{ width: '100%' }}
        name={label}
        onChange={onChange}
        iconPosition="left"
      >
        <Icon name="at" />
        <input />
      </Input>
    );
    return (
      <Menu.Item key={label}>
        <Accordion.Title
          active={activeIndex === index}
          content={config.translate(label, agentLang) || label}
          index={index}
          onClick={updateIndex}
          className={brandCode}
        />
        <Accordion.Content
          active={activeIndex === index}
          content={content}
        />
      </Menu.Item>
    );
  }

  if (specialOption.specialOptionType === 'rescheduleDate') {
    const getSelectedDate = () => specialOptionsState[label]?.value;

    const onChange = (date: Date) => {
      setSpecialOptionsState({ ...specialOptionsState, [label]: { value: date } });
      let newDispositions = selectedMultiDisposition.filter(
        d => !d.startsWith(`rescheduleDate#${specialOption.specialOptionDispositionPrefix}#`)
      );
      if (date) {
        newDispositions.push(
          `rescheduleDate#${specialOption.specialOptionDispositionPrefix}#${date.toISOString()}`
        );
      }
      setSelectedMultiDisposition(newDispositions);
    };

    const minDate = new Date();
    const maxDate = new Date();
    if (specialOption.maxDaysAhead) {
      maxDate.setDate(minDate.getDate() + specialOption.maxDaysAhead);
    } else {
      maxDate.setDate(minDate.getDate() + 2);
    }

    const localeMap: Record<string, string> = {
      en_US: 'en-US',
      fr_FR: 'fr-FR',
      ca_FR: 'fr-CA',
      de_DE: 'de-DE',
      es_ES: 'es-ES',
    };
    const localeKey = localeMap[agentLang] ?? agentLang?.replace('_', '-');

    const content = (
      <DatePicker
        locale={localeKey}
        showIcon
        selected={getSelectedDate()}
        onChange={onChange}
        showTimeSelect
        timeFormat="HH:mm"
        timeCaption="time"
        dateFormat="Pp"
        placeholderText={
          config.translate('Please choose a time', agentLang) || 'Please choose a time'
        }
        minDate={minDate}
        maxDate={maxDate}
      />
    );
    return (
      <Menu.Item key={label}>
        <Accordion.Title
          active={activeIndex === index}
          content={config.translate(label, agentLang) || label}
          index={index}
          onClick={updateIndex}
          className={brandCode}
        />
        <Accordion.Content id="rescheduleDatePicker" active={activeIndex === index} content={content} />
      </Menu.Item>
    );
  }

  return null;
};
